@use '@/scss/underscore' as _;

.container {
  > *:not(:first-child) {
    margin-top: _.unit(4);
  }
}

